
<template>
  <div>

    <b-button
      v-permission="'knowledge_items.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>

    <Grid :service="service" route_name="knowledge/items" :ref="'grid'">
      <template v-slot:actions="actions">
        <div class="flex flex-row gap-2">
          <feather-icon
            v-permission="`knowledge_items.edit`"
            icon="EditIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Editar',
              delay: { show: 100, hide: 100 }
            }"
            @click="edit(actions.row.id)"/>
          <feather-icon
            v-permission="'knowledge_items.detail'"
            icon="EyeIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Detalhar',
              delay: { show: 100, hide: 100 }
            }"
            @click="detail(actions.row.id)"/>
          <feather-icon
            v-permission="`knowledge_items.delete`"
            icon="Trash2Icon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
            v-tooltip.top="{
              content: 'Excluir',
              delay: { show: 100, hide: 100 }
            }"
            @click="destroy(actions.row)"/>
        </div>
      </template>
    </Grid>
  </div>
</template>


<script>
import KnowledgeService from '@/services/api/KnowledgeService'

import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    addNew() {
      this.$router.push('/knowledge/items/create')
    },
    grid() {
      return this.$refs['grid']
    },
    detail(id) {
      this.$router.push({
        name: 'knowledge-item-detail',
        params: {
          id: id
        }
      })
    },
    edit(id) {
      this.$router.push({
        name: 'knowledge-item-edit',
        params: {
          id: id
        }
      })
    },
    destroy(data) {
      const grid = this.grid()
      if (grid) {
        grid.destroy(data)
      }
    },
  },
  beforeMount() {
    this.service = KnowledgeService.build(this.$vs)
  }
}
</script>
